export default "__VITE_ASSET__DvedTiFx__"